<template>
  <div class="pricing-2">
      <div class="pricing-2" id="pricing-2">
        <div class="container">
          <div class="row">
            <div class="col-md-6 ml-auto mr-auto text-center">
              <h2 class="title">Pick the best plan for you</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <card type="pricing" plain>
                <h4 class="category">Tenant Find Service</h4>
                <h1 class="card-title">
                  <small>£</small>
                  450
                </h1>
                <ul>
                  <li>Tenants are fully vetted to set criteria to guarantee authenticity and all details provided by them</li>
                  <li>We legally cover you if you have any problems with tenants in the first 12 months</li>
                  <li>We will complete all relevant paperwork and contracts and forward to landlord</li>
                </ul>
                <a href="/contactus" class="btn btn-primary"> Sign Up </a>
              </card>
            </div>
            <div class="col-md-6">
              <card
                type="pricing"
                raised
                class="card-background"
                style="background-image: url('img/jgestates-home-1.jpg')"
              >
                <h4 class="category text-info">Fully Managed Service</h4>
                <h1 class="card-title">
                  £80 per month
                </h1>
                <ul>
                  <li>Tenants are fully vetted to a set criteria to guarantee authenticity and all details provided by them</li>
                  <li>We legally cover landlords if problems arise at any point during tenancy</li>
                  <li>Free inventory of the property is included</li>
                  <li>We guarantee that you will not lose out on any rent if tenants do not pay</li>
                  <li>Rent protection included as standard</li>
                  <li>We make sure all rent is paid on time to the landlord</li>
                  <li>Free eviction service should tenants cause any issues</li>
                </ul>
                <a href="/contactus" class="btn btn-neutral btn-primary"> Sign Up </a>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { Card, Button, Tabs, TabPane } from "@/components";
export default {
  components: {
    Card,
    Tabs,
    TabPane,
    [Button.name]: Button
  }
}
</script>

<style scoped>
.white-text {
  color: #fff;
}
</style>